import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiUsers, FiGitBranch, FiLink, FiHeart } = FiIcons;

export default function LegacyChainStats({ nodes, edges, memorialClusters }) {
  const crossEdges = edges.filter(e => e.crossMemorial).length;
  const deceased   = nodes.filter(n => n.isDeceased).length;

  const stats = [
    { icon: FiUsers,     label: 'People',          value: nodes.length,             color: 'text-accent-navy'  },
    { icon: FiGitBranch, label: 'Connections',      value: edges.length,             color: 'text-purple-600'   },
    { icon: FiLink,      label: 'Cross-Memorial',   value: crossEdges,               color: 'text-amber-600'    },
    { icon: FiHeart,     label: 'In Memoriam',       value: deceased,                 color: 'text-accent-gold'  },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {stats.map(s => (
        <div key={s.label} className="bg-brand-light rounded-2xl p-4 border border-brand-dark text-center">
          <SafeIcon icon={s.icon} className={`w-5 h-5 mx-auto mb-1 ${s.color}`} />
          <p className={`text-2xl font-serif ${s.color}`}>{s.value}</p>
          <p className="text-[9px] font-black uppercase tracking-widest text-text-muted">{s.label}</p>
        </div>
      ))}
    </div>
  );
}